import React from 'react';

import { styled } from '../theme';
import ButtonDropdown from './ButtonDropdown';
import Input from './Input';

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    '> :last-child': {
        flex: 1,
    },
});

const StyledInput = styled(Input)(({ theme }) => ({
    fontSize: '1.6rem',
    borderRadius: `0 ${theme.borderRadius.base}px ${theme.borderRadius.base}px 0`,
}));

const ButtonDropdownContainer = styled('div')(({ theme }) => ({
    width: 100,
    marginRight: -2,
}));

type Props = {
    name: string;
    value: string;
    onChange: (target: object) => void;
};

const HTTP_SCHEMA = 'http://';
const HTTPS_SCHEMA = 'https://';
const SCHEMA_OPTIONS = [HTTPS_SCHEMA, HTTP_SCHEMA];

const parseUrl = (url: string) => {
    const [host, schema] = url ? url.split('://').reverse() : ['', 'https'];

    return {
        schema: schema ? schema + '://' : HTTPS_SCHEMA,
        host: host ? host : '',
    };
};

class UrlInput extends React.PureComponent<Props> {
    handleChange = (value) => {
        const { name, onChange } = this.props;
        onChange({ target: { name, value } });
    };

    handleSchemaChange = (e: React.ChangeEvent<any>) => {
        const { host } = parseUrl(this.props.value);
        this.handleChange(e.target.value + host);
    };

    handleHostChange = (e: React.ChangeEvent<any>) => {
        let { schema, host } = parseUrl(e.currentTarget.value);

        if (!SCHEMA_OPTIONS.includes(schema)) {
            schema = parseUrl(this.props.value).schema;
        }

        this.handleChange(`${schema}${host}`);
    };

    render() {
        const { name, value } = this.props;
        const { schema, host } = parseUrl(value);

        return (
            <Container>
                <ButtonDropdownContainer>
                    <ButtonDropdown
                        options={SCHEMA_OPTIONS}
                        value={schema}
                        onChange={this.handleSchemaChange}
                        inputFieldStyle={{
                            padding: '5px 20px 5px 5px',
                        }}
                    />
                </ButtonDropdownContainer>

                <StyledInput
                    {...this.props}
                    name={name + '_host'}
                    value={host}
                    onChange={this.handleHostChange}
                />
            </Container>
        );
    }
}

export default UrlInput;
